module.exports = __webpack_public_path__ + "fonts/Gibson-Bold.8c5a992a.woff2";